export default __webpack_public_path__ + "static/media/logo.e145d350.png";